import * as React from "react";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";

import { BaseLabel, colors } from "components";

import { ISquare } from "./interface";
import { DateArea, Day, Hour, Container } from "./styles";

export const SquareCard: React.FC<ISquare> = ({
  id,
  title,
  subTitle,
  backgrounColor,
  height = 56,
  width = 60,
}) => {
  const DemoPaper = styled(Paper)(() => ({
    height: height,
    width: width,
    backgroundColor: backgrounColor ?? colors.background_light,
  }));

  return (
    <Container data-testid={id}>
      <Stack direction="row" spacing={2}>
        <DemoPaper square={false} elevation={0}>
          <DateArea>
            <Day>
              <BaseLabel
                children={title}
                fontSize="12px"
                fontWeight="bold"
                color={colors.neutral_black}
              />
            </Day>
            <Hour>
              <BaseLabel
                children={subTitle}
                fontSize="12px"
                fontWeight="400"
                color={colors.neutral_gray_40}
              />
            </Hour>
          </DateArea>
        </DemoPaper>
      </Stack>
    </Container>
  );
};
